import { COUNTRY_ALIAS } from '@/micro/modules/version'
import type { ApplicationVersion } from '@/micro/types/version.type'

export interface CountrySeo {
  country: ApplicationVersion
  slug: string
  hreflang: string
  title: string
}

export const LOGIN_COUNTRY_SEO: CountrySeo[] = [
  {
    country: 'argentina',
    slug: 'argentina',
    hreflang: 'es-AR',
    title: 'Alegra Argentina | Iniciar sesión',
  },
  {
    country: 'colombia',
    slug: 'colombia',
    hreflang: 'es-CO',
    title: 'Alegra Colombia | Iniciar sesión',
  },
  {
    country: 'spain',
    slug: 'spain',
    hreflang: 'es-ES',
    title: 'Alegra España | Iniciar sesión',
  },
  {
    country: 'mexico',
    slug: 'mexico',
    hreflang: 'es-MX',
    title: 'Alegra México | Iniciar sesión',
  },
  {
    country: 'republicaDominicana',
    slug: 'republicadominicana',
    hreflang: 'es-DO',
    title: 'Alegra República Dominicana | Iniciar sesión',
  },
  {
    country: 'costaRica',
    slug: 'costarica',
    hreflang: 'es-CR',
    title: 'Alegra Costa Rica | Iniciar sesión',
  },
  {
    country: 'panama',
    slug: 'panama',
    hreflang: 'es-PA',
    title: 'Alegra Panamá | Iniciar sesión',
  },
  {
    country: 'peru',
    slug: 'peru',
    hreflang: 'es-PE',
    title: 'Alegra Perú | Iniciar sesión',
  },
]

export const resolveLoginCountrySeo = (countryParam: unknown): CountrySeo | null => {
  if (typeof countryParam !== 'string') return null

  const country = (COUNTRY_ALIAS[countryParam] ?? countryParam) as ApplicationVersion

  return LOGIN_COUNTRY_SEO.find(seo => seo.country === country) ?? null
}
